/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosAddressTopSummaryListRequest = {
    sortField?: AptosAddressTopSummaryListRequest.sortField;
    sortDirection?: AptosAddressTopSummaryListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace AptosAddressTopSummaryListRequest {

    export enum sortField {
        BALANCE = 'BALANCE',
        COIN = 'COIN',
        NFT = 'NFT',
        TRANSACTION = 'TRANSACTION',
        FIRST_TRANSACTION = 'FIRST_TRANSACTION',
        LAST_TRANSACTION = 'LAST_TRANSACTION',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

